import PropTypes from "prop-types";
import React, { useContext } from "react";
import { createUseStyles } from "react-jss";
import { TranslationContext, StyleTypeContext } from "../../umbilical_tools";
import { LanguageLink, languageList } from "./helpers";
import _ from "lodash";
import { Icon } from "@iconify/react";
import jssVariables from "../../jss_setup";

const mainPanelStyles = createUseStyles({
  MainPanel: (props) => ({
    display: "grid",
    gridGap: jssVariables.half_gap,
    alignItems: "baseline",
    alignContent: "baseline",
    justifyItems: "end",
    gridTemplateRows: "max-content 1fr",
    height: "auto",
    width: "70vw",
    padding: jssVariables.half_gap,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -70%)",
    background: "transparent",
    ..._.get(props, "customStyles.MainPanel", {}),
  }),
  headerPanel: (props) => ({
    top: 0,
    display: "grid",
    gridTemplateColumns: "1fr max-content",
    alignItems: "center",
    ..._.get(props, "customStyles.headerPanel", {}),
  }),
  header: (props) => ({
    fontStyle: "normal",
    fontSize: "x-large",
    fontWeight: "bold",
    color: jssVariables.colors.text.dark,
    ..._.get(props, "customStyles.header", {}),
  }),
  closeIconSpan: (props) => ({
    ..._.get(props, "customStyles.closeIconSpan", {}),
  }),
  closeIcon: (props) => ({
    fontSize: "xx-large",
    cursor: "pointer",
    color: "white",
    ..._.get(props, "customStyles.closeIcon", {}),
  }),
  linksPanel: (props) => ({
    display: "grid",
    padding: `calc(${jssVariables.normal_gap} * 1.5)`,
    gridGap: `calc(${jssVariables.normal_gap} * 1.5)`,
    alignContent: "baseline",
    alignItems: "baseline",
    background: "white",
    borderRadius: jssVariables.half_gap,
    gridTemplateColumns: props.showMoreCols ? "1fr 1fr" : "1fr",
    marginTop: 0,
    marginRight: jssVariables.half_gap,
    overflow: "auto",
    height: "max-content",
    width: "100%",
    ..._.get(props, "customStyles.linksPanel", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    MainPanel: (props) => ({
      position: "unset",
      transform: "unset",
      zIndex: 3,
      display: "block",
      width: "max-content",
      ..._.get(props, "customStyles.MainPanel.smallscreen", {}),
    }),
    closeIcon: (props) => ({
      display: "none",
      ..._.get(props, "customStyles.closeIcon.smallscreen", {}),
    }),
  },
  [`@media ${jssVariables.media.bigscreen}`]: {},
});
export const MainPanel = ({
  languages = [],
  customStyles,
  closeLanguageModal,
}) => {
  const classes = mainPanelStyles({
    customStyles,
    showMoreCols: languages.length > 6,
  });

  const { i18n } = useContext(TranslationContext);

  function changelanguage(input) {
    i18n.changeLanguage(input);
    closeModal();
  }

  function closeModal() {
    closeLanguageModal();
  }
  return (
    <div className={classes.MainPanel}>
      <div className={classes.headerPanel}>
        <Icon
          icon="ic:baseline-close"
          className={classes.closeIcon}
          onClick={closeModal}
        />
      </div>
      <div className={classes.linksPanel}>
        {languages
          .map((lng) => _.upperCase(lng))
          .map((lang, idx) => (
            <LanguageLink
              key={idx}
              customStyles={customStyles}
              changelanguage={changelanguage}
              flagText={lang === "EN" ? "EN-US" : lang}
              lang={lang}
              label={
                lang === "EN"
                  ? "English (US)"
                  : languageList.find((obj) => obj.flagText === lang)?.label
              }
            />
          ))}
      </div>
    </div>
  );
};
MainPanel.defaultProps = { languages: [] };
MainPanel.propTypes = {
  languages: PropTypes.array.isRequired,
  customStyles: PropTypes.object,
  closeLanguageModal: PropTypes.func.isRequired,
};

const styles = createUseStyles({
  languageModal: (props) => ({
    position: "fixed",
    background: "rgba(0,0,0, 0.6)",
    left: "0px",
    top: "0px",
    width: "100vw",
    height: "100vh",
    zIndex: 9999,
    alignItems: "center",
    ..._.get(props, "customStyles.languageModal", {}),
  }),

  languagePopup: (props) => ({
    display: "none",
    ..._.get(props, "customStyles.languagePopup", {}),
  }),
  arrow: (props) => ({
    ..._.get(props, "customStyles.arrow", {}),
  }),
  content: (props) => ({
    ..._.get(props, "customStyles.content", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    languageModal: (props) => ({
      display: "none",
      // display: props.showModal ? "grid" : "none",
      gridTemplateRows: "auto 1fr",
      padding: "10vh 20vw",
      ..._.get(props, "customStyles.languageModal.smallscreen", {}),
    }),
    mainPanel: (props) => ({
      height: "max-content",
      ..._.get(props, "customStyles.mainPanel.smallscreen", {}),
    }),
    closeIconSpan: (props) => ({
      ..._.get(props, "customStyles.closeIconSpan.smallscreen", {}),
    }),
    linksPanel: (props) => ({
      marginTop: `calc(${jssVariables.normal_gap} * 4)`,
      gridAutoRows: "max-content",
      display: "grid",
      gridTemplateColumns: props.showMoreCols ? "repeat(3, 1fr)" : "1fr",
      justifyItems: "left",
      padding: `calc(${jssVariables.normal_gap} * 2)`,
      ..._.get(props, "customStyles.linksPanel.smallscreen", {}),
    }),
    languagePopup: (props) => ({
      display: "grid",
      justifyItems: "end",
      position: "absolute",
      top: jssVariables.half_gap,
      right: "-0.65rem",
      ..._.get(props, "customStyles.languagePopup.smallscreen", {}),
    }),
    arrow: (props) => ({
      transform: "rotate(-45deg)",
      width: jssVariables.double_gap,
      height: jssVariables.double_gap,
      background: "white",
      // boxShadow: "rgba(0, 0, 0, 0.2) 3px -2px 0px 0px",
      filter: "drop-shadow(1px -1px 1px rgba(0, 0, 0, 0.25))",
      zIndex: 1,
      position: "absolute",
      top: "2rem",
      right: "0.4rem",
      ..._.get(props, "customStyles.arrow.smallscreen", {}),
    }),
    content: (props) => ({
      // boxShadow: "rgba(0, 0, 0, 0.2) 3px -2px 0px 0px",
      filter: "drop-shadow(3px 2px 6px rgba(0, 0, 0, 0.25))",

      background: "white",
      borderRadius: jssVariables.half_gap,
      zIndex: 0,
      position: "absolute",
      top: "2.7rem",
      right: "-0.5rem",
      ..._.get(props, "customStyles.content.smallscreen", {}),
    }),
  },
});
const LanguageSelectorModal = ({
  languages,
  showModal,
  closeLanguageModal,
}) => {
  const { type, brand, cStyler } = useContext(StyleTypeContext);

  const customStyles = cStyler({
    type,
    brand,
    objName: "languageModal",
  });

  const classes = styles({ showModal, customStyles });

  return (
    <React.Fragment>
      <div className={classes.languageModal}>
        <MainPanel
          languages={languages}
          customStyles={customStyles}
          closeLanguageModal={closeLanguageModal}
        />
      </div>
      <div className={classes.languagePopup}>
        <div className={classes.arrow}></div>
        <div className={classes.content}>
          <MainPanel
            languages={languages}
            customStyles={customStyles}
            closeLanguageModal={closeLanguageModal}
          />
        </div>
      </div>
    </React.Fragment>
  );
};
LanguageSelectorModal.defaultProps = {
  showModal: false,
};
LanguageSelectorModal.propTypes = {
  languages: PropTypes.array.isRequired,
  showModal: PropTypes.bool.isRequired,
  closeLanguageModal: PropTypes.func.isRequired,
};

export default LanguageSelectorModal;
